import { ReactElement } from "react";

export function Input(props: {
  placeholder: string;
  value: string;
  type: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}): ReactElement {
  const { placeholder, value, type, onChange } = props;

  return (
    <input
      className="border-2 border-gray-200 focus:border-blue-400 focus:ring-0 text-gray-600"
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      maxLength={100}
    />
  );
}
